export enum AtiraLinkBackgroundImageSize {
  AUTO = 'auto',
  COVER = 'cover',
  CONTAIN = 'contain',
}
